<template>
    <div>
        <b-form-group
            :id="fieldId"
            :state="isValid"
            :invalid-feedback="invalidFeedback"
            :description="helpText"
            :label-cols="inline ? 'auto' : false"
        >
            <template v-slot:label>
                <label class="form-label">{{ fieldLabel }}: <slot></slot> </label>
            </template>
            <input
                :id="hourId"
                :class="inputClass"
                v-model="hour"
                @input="inputChanged($event, hourId, 'hour', 2)"
                @change="createDate"
                @focusin="focusInEvent($event, hourId, 'hour')"
                class="digits-2"
                inputmode="numeric"
                maxlength="2"
                :placeholder="$t('datefield.hourPlaceholder')"
            >
            <span class="mr-2">:</span>
            <input
                :id="minuteId"
                :class="inputClass"
                v-model="minute"
                @input="inputChanged($event, minuteId, 'minute', 2)"
                @change="createDate"
                @focusin="focusInEvent($event, minuteId, 'minute', 2)"
                class="digits-2"
                inputmode="numeric"
                maxlength="2"
                :placeholder="$t('datefield.minutePlaceholder')"
            >
        </b-form-group>
    </div>
</template>

<script>
    import fieldMixin from '@/components/fields/FieldMixin';
    import {isNull} from "@/utils/formatting";
    import moment from 'moment';
    import {required, minValue, maxValue} from "vuelidate/lib/validators";


    export default {
        name: "HourField",
        mixins: [fieldMixin],
        data() {
            return {
                hour: '',
                minute: '',
            };
        },
        computed: {
            hourId() {
                return this.prefix + 'hour';
            },
            minuteId() {
                return this.prefix + 'minute';
            },
            prefix() {
                return this.prefixFieldName ? this.prefixFieldName + '-' : '';
            },
            inputClass() {
                let clazz = 'mr-2 text-center';
                if (this.invalidFeedback !== '') {
                    return clazz + ' error';
                }
                return clazz;
            },
        },
        watch: {
            value(newValue) {
                this.separateValueInComponents(newValue);
            }
        },
        created() {
            this.separateValueInComponents(this.value);
        },
        methods: {
            separateValueInComponents(value) {
                if (!isNull(value) && this.hasTime(value)) {
                    let date = moment(this.value);
                    this.hour = date.format('HH');
                    this.minute = date.format('mm');
                }
            },
            createDate() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.innerErrors = [this.$t('datefield.invalidDate')];
                    return;
                } else {
                    this.innerErrors = [];
                }
                let dateObject = {
                    hour: this.hour,
                    minute: this.minute,
                };
                this.changeValue(dateObject);
            },
            inputChanged(event, sourceId, field, maxLength) {
                if (event.target.id === sourceId && this[field].toString().length >= maxLength) {
                    const nextInput = this.findNextInput(event.target);
                    if (nextInput) {
                        nextInput.focus();
                    } else {
                        event.target.blur();
                    }
                }
            },
            focusInEvent(event, sourceId, field) {
                if (event.target.id === sourceId && this[field].toString().length >= 0) {
                    event.target.select();
                }
            },
            findNextInput(element) {
                let returned = element.nextElementSibling;
                while (returned !== null) {
                    if (returned instanceof HTMLInputElement) {
                        return returned;
                    }
                    returned = returned.nextElementSibling;
                }
                return null;
            },
            hasTime(dateString) {
                // iso format 2020-05-12T08:52:16+00:00
                // when only date is received 2020-05-12 so if T is not in string is only a date
                return dateString.includes("T");
            }
        },
        validations: {
            hour: {
                required,
                minValue: minValue(0),
                maxValue: maxValue(23),
            },
            minute: {
                required,
                minValue: minValue(0),
                maxValue: maxValue(59),
            },
        }
    };
</script>

<style scoped>
    input {
        color: black;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 1px solid black;
        border-radius: 0;
    }
    .error {
        border-bottom: 1px solid red;
    }

    .digits-2 {
        width: 1.7rem;
    }

    .digits-2-month {
        width: 2rem;
    }

    .digits-4 {
        width: 2.5rem;
    }

    ::-webkit-input-placeholder {
        text-align: center;
        color: lightgrey;
    }

    :-moz-placeholder { /* Firefox 18- */
        text-align: center;
        color: lightgrey;
    }

    ::-moz-placeholder {  /* Firefox 19+ */
        text-align: center;
        color: lightgrey;
    }

    :-ms-input-placeholder {
        text-align: center;
        color: lightgrey;
    }
</style>